import React from 'react';

// Thin-line QPS seal: hairline circle, one roof line, monogram in the brand
// serif. Inherits color via currentColor unless overridden.
export default function Seal({ size = 80, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="50" cy="50" r="46.5" stroke={color} strokeWidth="1.6" />
      <path d="M31 49 L50 32 L69 49" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <text x="52" y="66" textAnchor="middle" fontFamily="'Cormorant Garamond',serif" fontSize="14" letterSpacing="4" fill={color}>QPS</text>
    </svg>
  );
}
